import { odinClient } from "@/config/client"

export interface Feedback {
  approvalScore: number
  scorePercentage: number
  bullets: string[]
}

export interface Review {
  review: string
  score: number
  correctAnswerIndex: number
}

export interface NextQuestionChallenge {
  index: number
  question: string
  options: string[]
}

export interface ChallengeActivity {
  id: string
  feedback: Feedback
  review: Review
  next: NextQuestionChallenge
  more: boolean
  total: number
  current: number
}

export interface UpdateChallengeStudySessionResponse {
  description: ChallengeActivity
}

interface UpdateStudySessionData {
  answerIndex?: number
  elapsedTimeInSeconds?: number
}

export function update(sessionId: string, activityId: string, data: UpdateStudySessionData) {
  return odinClient.put<UpdateChallengeStudySessionResponse, UpdateStudySessionData>(
    `/v1/activities/${activityId}/challenges/study-session/${sessionId}`,
    data,
  )
}
